module.exports = __webpack_public_path__ + "img/star3green.84ec6ef8.png";